import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import dayjs from 'dayjs';

import {
  MapGetRisCustom02R1ToProcesses,
  MergeSafetyProcessListWithRiskDetails,
} from '../RiskAssessment/RiskAssessment_Schema';
import { MapGetRisCustom01R1ResponseToForm } from '../Step01_SafetyInfo/SafetyInfo_Schema';

const Str = (v) => String(v ?? '').trim();

/** 개선보고서 저장 시 StepSeq — 다음 단계가 '진행중'(TB_SF_RISK_PROGRESS) */
export const IMPROVEMENT_SAVE_STEP_SEQ = 4;

/**
 * GetRisCustom01R1 + GetRisCustom02R1 병합 후,
 * 개선예정일·개선완료일·개선 후 빈도·개선 후 강도·개선 후 위험성(점수)이 모두 값이 있는 세부행만 개선보고서에 포함
 */
export const BuildImprovementReportRows = (safety01Raw, search02Raw) => {
  const patched = MapGetRisCustom01R1ResponseToForm(safety01Raw, {
    assessmentTitle: '',
  });
  const safetyPl = Array.isArray(patched?.processList)
    ? patched.processList
    : [];
  const risk02 = MapGetRisCustom02R1ToProcesses(search02Raw);
  const merged = MergeSafetyProcessListWithRiskDetails(safetyPl, risk02);

  const out = [];
  for (const proc of merged) {
    const depNm = Str(proc.depNm);
    const processNm = Str(proc.processNm);
    const details = Array.isArray(proc.details) ? proc.details : [];
    for (const d of details) {
      const gaesunExDate = Str(d.gaesunExDate);
      const gaesunComDate = Str(d.gaesunComDate);
      const afterPossibility = Str(d.afterPossibility);
      const afterImportance = Str(d.afterImportance);
      const afterCurrentRisk = Str(d.afterCurrentRisk);

      // 조건(다섯 항목 모두 값이 있을 때만 포함):
      // 개선예정일, 개선완료일, 개선 후 가능성(빈도), 중대성(강도), 개선 후 위험성(빈도×강도 등 점수)
      if (
        !gaesunExDate ||
        !gaesunComDate ||
        !afterPossibility ||
        !afterImportance ||
        !afterCurrentRisk
      ) {
        continue;
      }

      out.push({
        ...d,
        depNm,
        processNm,
        gongJongNm: processNm,
      });
    }
  }
  return out;
};

const EscapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** 서버 상대경로 / 절대 URL / data URL / blob → img src (위험성평가 실시 그리드 ResolvePhotoSrc 와 동일 규칙) */
export const ResolveImprovementPhotoSrc = (raw) => {
  const v = raw == null ? '' : String(raw).trim();
  if (!v) return '';
  const low = v.toLowerCase();
  if (
    low.startsWith('http://') ||
    low.startsWith('https://') ||
    low.startsWith('data:') ||
    low.startsWith('blob:')
  ) {
    return v;
  }
  if (low.startsWith('//') && typeof window !== 'undefined') {
    return `${window.location.protocol}${v}`;
  }
  const base = String(Global.file?.useUrl ?? '').replace(/\/?$/, '/');
  let path = v.replace(/\\/g, '/');
  if (base) {
    path = path.replace(new RegExp(`^${EscapeRegex(base)}files/`, 'i'), '');
  }
  path = path.replace(/^\/?files\//i, '');
  const enc = Commons.EncodeUrl(path);
  if (!enc) return '';
  const fileBase = Global.file?.useUrl;
  if (!fileBase) return '';
  return `${String(fileBase).replace(/\/?$/, '/')}files/${enc}`;
};

/** 완료일시 (개선완료일 GAESUN_COM_DATE) */
export const FormatGaesunComDateTime = (v) => {
  if (v == null || v === '') return '—';
  if (v instanceof Date && !Number.isNaN(v.getTime())) {
    return dayjs(v).format('YYYY-MM-DD HH:mm');
  }
  const s = String(v).trim();
  if (!s) return '—';
  if (s.length >= 16 && s.includes(' ')) return s.slice(0, 16);
  if (s.length >= 10) {
    const d = dayjs(s.slice(0, 10));
    return d.isValid() ? d.format('YYYY-MM-DD') : s;
  }
  const d = dayjs(s);
  return d.isValid() ? d.format('YYYY-MM-DD HH:mm') : s;
};

export const Improvement_Schema = {
  mapper: {
    /** GetRisCustom02R1 */
    search1: {
      RsCd: (_, context) => {
        const n = Number(context.rsCd);
        return Number.isFinite(n) && n > 0 ? n : 0;
      },
      SearchText: (_, context) =>
        Commons.EncryptAES(String(context.searchText ?? '').trim()),
    },
    /** SaveRisCustom03U1 — mapParamsBySchema(context: rsCd, stepSeq) */
    save1: {
      RsCd: (_, context) => Number(context.rsCd ?? 0),
      StepSeq: (_, context) => {
        const s = context.stepSeq;
        if (s != null && s !== '') return Number(s);
        return IMPROVEMENT_SAVE_STEP_SEQ;
      },
    },
  },
};
